package navigation

external fun encodeURIComponent(str: String): String
external fun decodeURIComponent(str: String): String

/** アプリ内の画面を表すルート */
sealed class Route {
    object NewsList : Route()
    data class NewsDetail(val id: String) : Route()
}

private const val NEWS_DETAIL_PREFIX = "/news/"

/**
 * URLハッシュ（例: "#/news/abc%2F123"）をルートに変換する。
 * 不正な形式やデコード失敗時は一覧ルートにフォールバックする。
 */
fun parseRoute(hash: String): Route {
    val path = hash.removePrefix("#")
    if (!path.startsWith(NEWS_DETAIL_PREFIX)) return Route.NewsList

    val encodedId = path.removePrefix(NEWS_DETAIL_PREFIX)
    if (encodedId.isBlank()) return Route.NewsList

    return try {
        Route.NewsDetail(decodeURIComponent(encodedId))
    } catch (e: dynamic) {
        Route.NewsList
    }
}

/** ニュース詳細ページへのハッシュを生成する（IDはURL由来の文字を含むためエンコード必須） */
fun newsDetailHash(id: String): String = "#$NEWS_DETAIL_PREFIX${encodeURIComponent(id)}"
